import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../settings/index';
import KioskSettingsDetailsPage from '@/features/kiosk/pages/KioskSettingsDetailsPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/$id',
  component: KioskSettingsDetailsPage,
});
